<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark rounded small class="mx-2" v-bind="attrs" v-on="on">
                Create Record Folder
                <v-icon>mdi-plus</v-icon>
                </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Create New Folder</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="title" label="Title"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="name" label="Name"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field v-model="description" label="Description"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="security_level"
                        :items="security_level_items"
                        label="Security Level"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" v-if="errorMessage">
                      <h3 class="text-center red--text"> {{ errorMessage }} </h3>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="saveNewCategory">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-col>
    </v-row>
    <v-row v-show="showSuccess">
      <v-col cols="12">
        <v-alert dense text type="success" dismissible>Created new Record Folder</v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from 'sweetalert2';

export default {
  name: "RecordFolderModal",
  data() {
    return {
      name: "",
      title: "",
      security_level: '',
      description: '',
      categoryId: this.$route.params.id,
      errorMessage: null,
      status: "Active",
      dialog: false,
      showSuccess: false,
      security_level_items: ['Low', 'Moderate', 'High'],
    };
  },
  methods: {
    ...mapActions(["createRecordFolder"]),
    async saveNewCategory() {
      this.errorMessage = null;
      const body = {
        record_category_id: this.categoryId,
        name: this.name,
        title: this.title,
        description: this.description,
        security_level: this.security_level
      };
      const create = await this.createRecordFolder(body);
      if(create.error) {
        if(create.status == 400) this.errorMessage = create.message;
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Internal Server Error',
          })
        }
      } else if(create) {
        this.showSuccess = true;
        this.name = '';
        this.title = '';
        this.security_level = '';
        this.description = '';
        this.errorMessage = null;
        this.dialog = false;
      }
    },
    close() {
      this.dialog = false;
      this.errorMessage = null;
    },
  },
};
</script>

<style>
</style>